import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Preloader imports
import Preloader from "./components/Preloader/Preloader";

// Nabar imports
import Navbar from "./components/Navbar/Navbar";

// Main Nav imports
import MarketplacePage from "./components/Marketplace/MarketplacePage"
import LoadBoardPage from "./components/Loads/LoadBoardPage";
import PostLoadPage from "./components/Company/CompanyPages/PostLoadPage";
import TrustStrip from "./components/Pages/TrustStrip";
import PricingPage from "./components/Pages/PricingPage";
import ValueBlocks from "./components/ValueBlocks/ValueBlocksPage"
import CertStrip from "./components/CertStrip/CertStripPage"
import EnterpriseSection from "./components/Enterprise/Enterprise";
import  MembershipTeaser from "./components/Membership/Membership";
import TrainingPage from "./components/Training/TrainingHub"
import CTA from "./components/CTA/CTA";
import DisclaimerPage from "./components/Legal/Disclaimer"

import MyLoads from "./components/Company/CompanyPages/MyLoads";

import Analytics from "./components/Company/CompanyPages/Analytics";

import CrashCourseLanding from "./components/CrashCourse/CrashCourseLanding";
import CrashCourseView from "./components/CrashCourse/CrashCourseView";
import StateInfographic from "./components/CrashCourse/StateInfographic";
import PostExamVerification from "./components/CrashCourse/PostExamVerification";
import PPCAWashingtonStatesCrashCourse from "./components/CrashCourse/PPCAWashingtonStatesCrashCourse";
import PPCAVerificationTab from "./components/CrashCourse/PPCAVerificationTab"
import DriverVerificationBadge from "./components/Verified/PilotLinkConsole";
import DispatcherConsole from "./components/Verified/DispatcherConsole";
import PPCAAllStatesCrashCourse from "./components/CrashCourse/PPCAAllStatesCrashCourse";



// Auth imports
import PilotLogin from "./components/Auth/PilotLogin"
import CompanyLogin from "./components/Auth/CompanyLogin";
import DispatcherLogin from "./components/Auth/DispatcherLogin";
import Signup from "./components/Auth/SignupTemp";

import Footer from "./components/Footer/Footer";


// Hero imports
import Hero from "./components/Hero/HeroPage";
import BecomePartner from "./components/Hero/BecomePartnerPage";

// Test imports
import TestPilotMasterv2 from "./TestPages/TestPilotMasterv2";
import TestPPCAStudyGuide from "./TestPages/TestPPCAStudyGuide";
import TestUnifiedDashboard from "./TestPages/TestUnifiedDashboard";
import TestPPCAVerifyChecklist from "./TestPages/TestPPCAVerifyChecklist";
import TestDispatcherConsole from "./TestPages/TestDispatcherConsole";
import TestCertVerify from "./TestPages/TestCertVerifyPage";

// DriverDashboardPage
import DriverDashboardPage from "./components/Users/DriverDashboardPage";

// DriverDashboardPage
import CompanyDashboardPage from "./components/Company/CompanyDashboard";


// ── Legal pages (required for Stripe live payments) ───────────────────────────
import PrivacyPolicy    from "./components/Legal/PrivacyPolicy";
import CopyrightNotice  from "./components/Legal/CopyrightNotice";
import TermsOfService   from "./components/Legal/TermsOfService";
import RefundPolicy     from "./components/Legal/RefundPolicy";
import ContactUs        from "./components/Legal/ContactUs";
import UniversalChat    from "./components/Chat/UniversalChat";
import PostListing      from "./components/Marketplace/PostListing";
import TradeLinkInbox   from "./components/Marketplace/TradeLinkInbox/TradeLinkInbox";
import TradeLinkDashboard from "./components/Marketplace/TradeLinkDashboard";


import ScrollToTop from "./components/Pages/ScrollToTop";

// Dispatcher Dashboard Pages
import DispatcherDashboard from "./components/Dispatcher/DispatcherDashboard";

// Not found imports
import NotFound from "./components/NotFound/404NotFound";
import ForgotPassword from "./components/Auth/ForgotPassword";
import ResetPassword from "./components/Auth/ResetPassword";
import CheatSheetVault from "./components/CrashCourse/CheatSheetVault";
import PeterQAWidget from "./TestPages/PeterQAWidget";
import StarterBundleLanding from "./TestPages/StarterBundleLanding";


export default function App() {
  const [loading, setLoading] = useState(true);

  const defaultTheme = process.env.REACT_APP_DEFAULT_THEME || "light";

const [theme, setTheme] = useState(() => {
  if (typeof window === "undefined") return defaultTheme;

  const savedTheme = localStorage.getItem("theme");
  return savedTheme ? savedTheme : defaultTheme;
});
  // Handle Preloader
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  // Handle Dark/Light Mode toggle at the DOM level & save to localStorage
  useEffect(() => {
    const root = window.document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    localStorage.setItem("theme", theme); // Save preference so it persists on refresh
  }, [theme]);

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  if (loading) {
    return <Preloader />;
  }

  // We bundle the Landing Page UI into a single component so it only shows on the "/" route
  const LandingPage = () => (
    <>
     {/* Pass the boolean evaluation to Navbar so we don't break your existing Navbar props */}
      <Navbar isDarkMode={theme === "dark"} toggleTheme={toggleTheme} />
      <main>
        
          <Hero isDarkMode={theme === "dark"} />
          
          {/* Note: You will also need to pass this to your other components 
              if they use the DARK/LIGHT token system */}
          <TrustStrip isDarkMode={theme === "dark"} />
          {/* <ValueBlocks isDarkMode={theme === "dark"} /> */}
          {/* <CertStrip isDarkMode={theme === "dark"} /> */}
          {/* <EnterpriseSection isDarkMode={theme === "dark"} /> */}
          <MembershipTeaser isDarkMode={theme === "dark"} />
          
          <CTA isDarkMode={theme === "dark"} />
       
       {/*} <TrustStrip />
         <ValueBlocks />
        <CertStrip />
      <EnterpriseSection />
      <MembershipTeaser />
        <Training />
        <CTA />
      <FinalCTA /> */}
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 transition-colors duration-500 dark:bg-slate-950 dark:text-white">
      <Router>
        <Routes>
          {/* Landing Page Route */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/marketplace" element={<MarketplacePage isDarkMode={theme === "dark"} toggleTheme={toggleTheme} />} />
          <Route path="/load-board" element={<LoadBoardPage isDarkMode={theme === "dark"} toggleTheme={toggleTheme} />} />
          <Route path="/post-load" element={<PostLoadPage isDarkMode={theme === "dark"} toggleTheme={toggleTheme} />} />
          <Route path="/training" element={<TrainingPage isDarkMode={theme === "dark"} toggleTheme={toggleTheme} />} />
          <Route path="/pricing" element={<PricingPage isDarkMode={theme === "dark"} toggleTheme={toggleTheme} />} />
          <Route path="/disclaimer" element={<DisclaimerPage isDarkMode={theme === "dark"} toggleTheme={toggleTheme} />} />
           {/* Authentication Routes */}
          <Route path="/login" element={<PilotLogin />} />
          <Route path="/company-login" element={<CompanyLogin />} />
          <Route path="/dispatcher-login" element={<DispatcherLogin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/become-partner" element={<BecomePartner />} />
          

          <Route path="/signup" element={<Signup />} />



          {/* NEW: Driver Dashboard Route */}
          <Route path="/user-dashboard" element={<DriverDashboardPage />} />

          {/* NEW: Company Dashboard Route */}
          <Route path="/company-dashboard" element={<CompanyDashboardPage />} />
          <Route path="/my-loads" element={<MyLoads />} />
          <Route path="/analytics" element={<Analytics />} />



          {/* Dispatcher Dashboard Route*/}
          <Route path="/dispatcher-dashboard" element={<DispatcherDashboard />} />

          {/* ── Crash Course Routes ── */}
          {/* Landing / sales page — shown to everyone */}
          <Route path="/training/crash-course" element={<CrashCourseLanding isDarkMode={theme === "dark"} toggleTheme={toggleTheme} />} />
          {/* Course reader — shown after purchase/login */}
          <Route path="/training/crash-course/study" element={<CrashCourseView />} />

          <Route path="/training/crash-course/state-infographic" element={<StateInfographic />} />

          <Route path="/training/crash-course/post-exam-verification" element={<PostExamVerification />} />
           <Route path="/training/all-states-cheat-sheet" element={<CheatSheetVault />} />

        {/* PPCA Crash Course Routes */}
        <Route path="/training/ppca-all-states-crash-course" element={<PPCAAllStatesCrashCourse isDarkMode={theme === "dark"} toggleTheme={toggleTheme} />} />

        <Route path="/training/ppca-washington-states-crash-course" element={<PPCAWashingtonStatesCrashCourse isDarkMode={theme === "dark"} toggleTheme={toggleTheme} />} />

         <Route path="/training/ppca-verificationtable" element={<PPCAVerificationTab isDarkMode={theme === "dark"} toggleTheme={toggleTheme} />} />
        <Route path="/pilot-user-verification-badge" element={<DriverVerificationBadge isDarkMode={theme === "dark"} toggleTheme={toggleTheme} />} />
        <Route path="/dispatcher-console" element={<DispatcherConsole isDarkMode={theme === "dark"} toggleTheme={toggleTheme} />} />




          <Route path="/test-pilotv2" element={<TestPilotMasterv2 />} />
          <Route path="/test-ppca-doc-verification" element={<TestPPCAVerifyChecklist />} />
          <Route path="/test-ppcastudyguide" element={<TestPPCAStudyGuide />} />
          <Route path="/test-dispatcherconsole" element={<TestDispatcherConsole />} />
          <Route path="/test-unifieddashboard" element={<TestUnifiedDashboard />} />
           <Route path="/test-certverify" element={<TestCertVerify />} />
            <Route path="/test-starterbundle" element={<StarterBundleLanding />} />


          {/* Unified Messaging (all roles) */}
          <Route path="/messages"             element={<UniversalChat  />}/>
          <Route path="/tradelink/post-listing"        element={<PostListing    />}/>

          {/* TradeLink Inbox */}
          <Route path="/tradelink/inbox" element={<TradeLinkInbox />}/>

          <Route path="/tradelink/inbox1" element={<TradeLinkDashboard />}/>
          {/* ── Legal (required by Stripe for live payments) ────────────── */}
          <Route path="/copyright"         element={<CopyrightNotice />} />
         <Route path="/privacy"          element={<PrivacyPolicy />} />
          <Route path="/privacy-policy"   element={<PrivacyPolicy />} />
          <Route path="/terms"            element={<TermsOfService />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/refund-policy"    element={<RefundPolicy />} />
          <Route path="/contact"          element={<ContactUs />} />

          {/* 2. Add this exactly at the BOTTOM of all your other routes */}
        <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>

  <PeterQAWidget/>
      {/* <WhatsAppBot /> */}

    </div>
  );
}
